import { Trans, useTranslation } from 'react-i18next';

import ListingCard from '../ListingCard';
import { listings } from '../../data/listings';

export default function Listings() {
  const { t } = useTranslation();

  return (
    <section id="stays" className="bg-bg px-6 pb-20 pt-28 md:px-10 md:pt-32">
      <header className="mb-14 flex flex-wrap items-end justify-between gap-6">
        <div>
          <div className="mb-3 text-xs uppercase tracking-[0.12em] text-accent">
            ❋&nbsp;&nbsp;{t('listings.eyebrow', { count: listings.length })}
          </div>
          <h2 className="m-0 text-balance font-display font-semibold leading-none tracking-display text-ink [font-size:clamp(40px,5vw,68px)]">
            <Trans i18nKey="listings.headline" components={{ break: <br /> }} />
          </h2>
        </div>
        <p className="m-0 max-w-[380px] text-[16px] leading-[1.55] text-muted">{t('listings.lede')}</p>
      </header>

      <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
        {listings.map((listing, i) => (
          <ListingCard key={listing.id} listing={listing} index={i} />
        ))}
      </div>
    </section>
  );
}
